var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-coupon__brandSelect my-3"},[_c('dropdown-select',{attrs:{"name":"coupon-brand-select","list":_vm.selectList,"value":_vm.selected},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }